import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core'
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms'
import { Textarea } from 'primeng/textarea'
import { IftaLabel } from 'primeng/iftalabel'
import { createFormControlBinding, FieldGroup } from '@core/utils/form-utils'

@Component({
  selector: 'albert-textarea',
  standalone: true,
  imports: [ReactiveFormsModule, Textarea, IftaLabel],
  templateUrl: './albert-textarea.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class AlbertTextareaComponent {
  public readonly groupName = input.required<string>()
  public readonly label = input.required<string>()
  public readonly inputId = input.required<string>()
  public readonly controlName = input<string>('value')
  public readonly placeholder = input<string>('')
  public readonly rows = input<number>(3)
  public readonly autoResize = input<boolean>(false)
  public readonly disabled = input<boolean>(false)
  public readonly required = input<boolean>(false)

  private readonly parentGroupDir = inject(FormGroupDirective)
  private readonly binding = createFormControlBinding(this.groupName, this.controlName, this.disabled)

  public readonly control = this.binding.control

  public get isUpdatedByOrigami(): boolean {
    return this.binding.isUpdatedByOrigami()
  }

  public get showRequiredHint(): boolean {
    if (!this.required()) return false

    const ctrl = this.control()
    const val: unknown = ctrl?.value
    return (val === null || val === undefined || val === '') && !this.disabled()
  }

  private get group(): FieldGroup<string> | null {
    return this.parentGroupDir.form.get(this.groupName()) as FieldGroup<string> | null
  }

}
